module.exports = __webpack_public_path__ + "media/images/logos/logo-glin-santa-claus-87dd5853e092d0569a00bb75097e39b0.svg";